import React from 'react';
import classNames from 'classnames';
import { DialogActions as MuiDialogActions } from '@material-ui/core';
import { makeStyles } from "../../styles/index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        padding: theme.spacing(1, 5),
        borderColor: theme.palette.light.divider,
        borderStyle: 'solid',
        borderWidth: 0,
        borderTopWidth: theme.shape.borderWidth.normal,
        justifyContent: 'center',
    },
}); }, { name: 'SnDialogActions' });
/**
 * ダイアログアクション（フッターのボタンコンテナ）コンポーネント。
 */
export var DialogActions = function (props) {
    var classes = useStyles(props);
    return (React.createElement(MuiDialogActions, { className: classNames(classes.root, props.className), style: props.style }, props.children));
};
